import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';
import SortedTooltip from './SortedTooltip';

interface Props {
  data: Record<string, string | number>[];
}

const OrderOriginsTrendChart = ({ data }: Props) => {
  if (!data?.length) return null;

  return (
    <div className="bg-white rounded-lg shadow p-4 w-full">
      <h3 className="text-sm font-semibold text-gray-700 mb-4">Order Origins — Last 6 Months</h3>
      <ResponsiveContainer width="100%" height={220}>
        <LineChart data={data} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="month" tick={{ fontSize: 12 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 12 }} />
          <Tooltip content={<SortedTooltip />} />
          <Legend />
          <Line type="monotone" dataKey="WhatsApp" stroke="#10b981" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
          <Line type="monotone" dataKey="Website" stroke="#3b82f6" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
          <Line type="monotone" dataKey="App" stroke="#a855f7" strokeWidth={2} dot={{ r: 3 }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OrderOriginsTrendChart;
